<template>
  <div class="news-location">
    <div class="container-fluid">
      <b-form class="province-search-form" @submit.prevent="onSubmit">
        <b-form-group>
          <fa-icon icon="search" class="input-icon"></fa-icon>
          <img
              class="input-clear"
              src="../assets/img/common/input-clear.png"
              alt="Search Clear"
              @click="searchClear">
          <b-form-input
              v-model="provinceSearchForm.keyword"
              class="form-control-custom"
              placeholder="ค้นหาจังหวัด">
          </b-form-input>
        </b-form-group>
      </b-form>

      <template v-for="(province, index) in provinces">
        <div
            :key="index"
            class="province"
            @click="$router.push(`/news/province/${province.province_code}/districts`)">
          {{ province.province }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'news-location',

    computed: {
      // Map Vuex state.
      ...mapState({
        provinces: state => {
          return state.ThailandLocation.provinces
        },
        provinceSearchForm: state => {
          return state.ThailandLocation.provinceSearchForm
        }
      })
    },

    created () {
      return this.$store.dispatch('ThailandLocation/getProvinces')
    },

    methods: {
      onSubmit () {
        return this.$store.dispatch('ThailandLocation/getProvinces')
      },
      searchClear () {
        this.$store.dispatch('ThailandLocation/setProvinceSearchForm', {
          keyword: ''
        })
          .then(() => this.$store.dispatch('ThailandLocation/getProvinces'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .news-location {
    padding: 20px 0;
    .province {
      @extend .cursor-pointer;
      line-height: 40px;
      font-size: 18px;
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsLocation.component.vue